<template>
  <!-- 实时数据 -->
  <div class="body">
    <div class="titleCont">
      <!-- 查询 -->
      <div>
        <DatePicker
          type="month"
          :placeholder="$t('请选择')"
          v-model="selectedMonth"
          style="width: 200px"
        ></DatePicker>
        <Button type="primary" class="btn">{{ $t("query") }}</Button>
        <Button type="error" class="btn">{{ $t("reset") }}</Button>
      </div>
      <!-- 累计 -->
      <div>
        <p>{{ $t("累计发电量") }} ： 1111</p>
        <p>{{ $t("累计用电量") }} ： 1111</p>
      </div>
    </div>
    <nbqEcharts
      :xdata="['1月', '10月', '12月']"
      :ydata="[
        [1, 2, 3],
        [4, 5, 6],
      ]"
    />
    <div class="BAT">
      <div
        v-for="(item, index) in bats"
        :key="index"
        :class="['bat-item', { active: selected === index }]"
        @click="selectBat(index)"
      >
        {{ item }}
      </div>
    </div>
    <div class="center">
      <div class="titleName">SOC:</div>
      <div class="dcIcon">
        <div><img :src="getImageSrc(19)" alt="" style="width: 58px" /></div>
        <div>19%</div>
      </div>
      <div class="titleName">SOH:</div>
      <div class="dcIcon">
        <div><img :src="getImageSrc(99)" alt="" style="width: 58px" /></div>
        <div>99%</div>
      </div>
    </div>
    <div class="footerOne">
      <div class="center">
        <div class="titleName">电池类型:</div>
        <div>99</div>
        <div class="titleName">电池AH数:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">电芯数量:</div>
        <div>99</div>
        <div class="titleName">并包数量:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">电池电压:</div>
        <div>99</div>
        <div class="titleName">电池电流:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">最高电芯电压:</div>
        <div>99</div>
        <div class="titleName">最低电芯电压:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">最高电芯温度:</div>
        <div>99</div>
        <div class="titleName">最低电芯温度:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">实时功率:</div>
        <div>99</div>
        <div class="titleName"></div>
        <div></div>
      </div>
    </div>
    <div class="footerOne">
      <div class="center">
        <div class="titleName">电网电压:</div>
        <div>99</div>
        <div class="titleName">电网电流:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">电网频率:</div>
        <div>99</div>
        <div class="titleName">电网功率:</div>
        <div>991</div>
      </div>
    </div>
    <div class="footerOne">
      <div class="center">
        <div class="titleName">负载功率:</div>
        <div>99</div>
        <div class="titleName">交流输出频率:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">交流输出电压:</div>
        <div>99</div>
        <div class="titleName">交流输出电流:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">逆变输出视在功率:</div>
        <div>99</div>
        <div class="titleName">逆变输出有功功率:</div>
        <div>991</div>
      </div>
    </div>
    <div class="footerOne">
      <div class="center">
        <div class="titleName">并机输出功率:</div>
        <div>99</div>
        <div class="titleName">并机状态:</div>
        <div>991</div>
      </div>
      <div class="center">
        <div class="titleName">并机地址:</div>
        <div>99</div>
        <div class="titleName"></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import nbqEcharts from "./nbqEcharts";
export default {
  name: "realtimedata",
  data() {
    return {
      bats: ["BAT1", "BAT2", "BAT3"],
      selected: 0, // 默认选中 BAT1
      selectedMonth: this.getCurrentMonth(),
    };
  },
  components: {
    nbqEcharts,
  },
  methods: {
    getCurrentMonth() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 获取当前月份，注意要加1
      return `${year}-${month < 10 ? "0" + month : month}`; // 格式化为 "YYYY-MM"
    },
    selectBat(index) {
      this.selected = index; // 更新选中的索引
    },
    getImageSrc(value) {
      if (value >= 0 && value <= 10) {
        return require("@/assets/images/lowD.png");
      } else if (value >= 11 && value <= 30) {
        return require("@/assets/images/centerD.png");
      } else if (value >= 31 && value <= 60) {
        return require("@/assets/images/heightD.png");
      } else if (value >= 61 && value <= 100) {
        return require("@/assets/images/fullD.png");
      }
      return ""; // 默认值
    },
  },
  mounted(){
    console.log('selectedMonth',this.selectedMonth);

  }
};
</script>

<style scoped>
.body {
  padding: 16px;
  margin: 16px;
  background: white;
}
.btn {
  margin-left: 26px;
}
.titleCont {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.BAT {
  display: flex;
  gap: 10px;
  margin-top: 36px;
}

.bat-item {
  padding: 10px;
  cursor: pointer;
  color: black; /* 默认颜色 */
}

.bat-item.active {
  color: #3398db; /* 选中时的颜色 */
  font-weight: bold; /* 可选：加粗 */
}
.center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0 16px 16px;
}
.center div {
  width: 25%;
}
.footerOne {
  border: 1px solid #ccc;
  border-radius: 16px;
  margin-top: 26px;
}
.dcIcon {
  display: flex;
  align-items: center;
}
</style>
